import { uiComponents, uiStates } from '@/tools/viewState';

import { actionTypes, mutationTypes } from '@/types';

import { generateUUID } from '@/tools/helpers';
import { getLangLanguageConent, getValueLanguageConent } from '@/tools/languageValue';
import { setUrlToDataSource } from '@/tools/setUrlToDataSource';
import { SEARCH_SCOPES } from '@/tools/consts';
/**
 * This action open the ui--search with scope location,
 * it shows all locations given by ID and coresponding articles
 *
 * @param {*} store
 * @param {locationIDs} options
 */
export default function({ rootState, commit, dispatch }, { locationIDs, options, isExhibition }) {
	const data = locationIDs.reduce((acc, locationID) => {
		const location = rootState.dataSourceCFG.locationMap[locationID];
		if (!isExhibition) {
			acc.push({
				id: location._id,
				name: location._id,
				class: `separator--${location._id}`,
				isSeperator: true,
				iconName: 'separator',
				role: 'link',
				...location.articles
					.map(article => article.article.languageContent)
					.reduce(
						(acc, lc) => {
							if (lc.title) acc.title[lc.languageISO] = lc.title;
							if (lc.description) acc.description[lc.languageISO] = lc.description;
							if (lc.coverImage)
								acc.cover[lc.languageISO] = lc.coverImage
									? setUrlToDataSource(`../media-${lc.coverImage}/512`, rootState.dataSourceURL)
									: undefined;
							return acc;
						},
						{ title: {}, description: {}, cover: {} }
					),
			});
		}

		location.tours.forEach(tour => {
			const languageContent = getLangLanguageConent(tour.languageContent);
			const { source } = tour.coverID.languageContent.filter(
				lc => lc.languageISO === rootState.persistent.language
			)[0];
			languageContent.cover = setUrlToDataSource(`../media-${source}/512`, rootState.dataSourceURL);
			acc.push({
				name: tour.name,
				class: 'data--' + tour.name,
				active: `${rootState.tour.tourCurrentID === tour._id}`,
				url: '',
				click: () => {
					dispatch(actionTypes.tourStart, { tourID: tour._id });
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchLocations,
						uiState: uiStates.hidden,
					});
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiMap,
						uiState: uiStates.hidden,
					});
				},
				...languageContent,
				title: getValueLanguageConent(tour.languageContent, 'title'),
				description: getValueLanguageConent(tour.languageContent, 'description'),
			});
		});

		location.articles.forEach(({ article, exhibitionID }) => {
			const languageContent = getLangLanguageConent(article.languageContent);
			languageContent.cover = languageContent.coverImage
				? setUrlToDataSource(`../media-${languageContent.coverImage}/512`, rootState.dataSourceURL)
				: undefined;

			acc.push({
				key: generateUUID(),
				name: article.name,
				class: 'data--' + article.name,
				active: `${rootState.articleContent.hasOwnProperty(article.id)}`,
				url: '',
				click: () => {
					if (rootState.tour.tourCurrentID) {
						dispatch(actionTypes.pushUrl, {
							url: `/${exhibitionID}/tour/${rootState.tour.tourCurrentID}/${article.id}`,
							replace: false,
						});
					} else {
						dispatch(actionTypes.setExhibition, { exhibitionID, articleID: article.id });
					}
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiSearchLocations,
						uiState: uiStates.hidden,
					});
					commit(mutationTypes.viewStateSetUiState, {
						id: uiComponents.uiMap,
						uiState: uiStates.hidden,
					});
				},
				...languageContent,
				title: getValueLanguageConent(article.languageContent, 'title'),
				description: getValueLanguageConent(article.languageContent, 'description'),
			});
		});
		return acc;
	}, []);
	// const alterationFunctions = [
	// 	function(array) {
	// 		return state.query ? array.filter(entry => !entry.isSeperator) : array; // remove seperators on query results
	// 	},
	// ];
	commit(mutationTypes.searchSetData, {
		scope: SEARCH_SCOPES.locations,
		data,
		searchOptions: {
			keys: ['title', 'description'],
			threshold: 0.3,
			caseSensitive: false,
		},
		options: Object.assign({}, options, { closeButton: !isExhibition }),
	});
	commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiSearchLocations,
		uiState: uiStates.maximised,
	});
}
